import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import type { GovernancePolicyFormData } from '@experiences/interfaces';
import { UiSuspensefulOutlet } from '@experiences/ui-common';
import React, { useState } from 'react';
import { useLocation } from 'react-router';

import { GovernanceCreateContent } from './GovernanceCreateContent';
import { GovernancePolicyCreateWizard } from './GovernancePolicyCreateWizard';

interface GovernanceCreateRouterProps {
    onSubmitHandler: (data: GovernancePolicyFormData) => Promise<void>;
    initialStep?: number;
    mode?: 'create' | 'edit';
    returnUrl?: string;
}

export const GovernanceCreateRouter: React.FC<GovernanceCreateRouterProps> = ({
    onSubmitHandler,
    initialStep,
    mode = 'create',
    returnUrl,
}) => {
    const EnableGovernancePolicyTemplates = useFeatureFlagValue(Features.EnableGovernancePolicyTemplates.name);
    const [ showStartComponent, setShowStartComponent ] = useState(EnableGovernancePolicyTemplates);
    const location = useLocation();

    const isChildRoute = location.pathname.includes('/resources') ||
        location.pathname.includes('/automations') ||
        location.pathname.includes('/access-decision');

    if (isChildRoute) {
        return <UiSuspensefulOutlet />;
    }

    if (!EnableGovernancePolicyTemplates) {
        return (
            <GovernancePolicyCreateWizard
                onSubmitHandler={onSubmitHandler}
                initialStep={initialStep}
                mode={mode}
                returnUrl={returnUrl}
            />
        );
    }

    return (
        <GovernanceCreateContent
            showStartComponent={showStartComponent}
            setShowStartComponent={setShowStartComponent}
            onSubmitHandler={onSubmitHandler}
            initialStep={initialStep}
            mode={mode}
            returnUrl={returnUrl}
        />
    );
};
